export enum HitType {
  Bullet,
  Explosion,
}

/**
 * Interface for entities that can be hit by bullets
 */
export interface Hittable {
  /**
   * Handle being hit by a bullet
   * @param damage Amount of damage to take
   */
  takeHit(damage: number, hitType: HitType): void;
}

/**
 * Type guard to check if an entity implements the Hittable interface
 * @param entity The entity to check
 * @returns True if the entity is hittable
 */
export function isHittable(entity: unknown): entity is Hittable {
  return (
    Boolean(entity) &&
    typeof entity === "object" &&
    entity !== null &&
    "takeHit" in entity &&
    typeof entity.takeHit === "function"
  );
}
